module.exports = __webpack_public_path__ + "static/media/loader.244587d9.svg";